import { RouteObject } from 'react-router'
import { Overview } from './overview'
import { Root } from './root'

export const REPORTING_ROUTES: RouteObject = {
	path: 'reporting',
	element: <Root />,
	children: [
		{
			path: '',
			element: <Overview />,
		},
	],
}
